import { Component, OnInit, Input, ViewChild, inject } from '@angular/core';
import {
  HeaderComponent,
  SideNavigationMenuComponent,
} from '../../shared/components';
import { ScreenService } from '../../shared/services';
import { DxDrawerComponent } from 'devextreme-angular/ui/drawer';
import {
  DxScrollViewComponent,
} from 'devextreme-angular/ui/scroll-view';


import { Router, NavigationEnd } from '@angular/router';
import { DxTemplateDirective } from 'devextreme-angular';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { RUOLO_OPERATORE_BASE } from 'src/app/consts/const';

@Component({
  selector: 'app-side-nav-outer-toolbar',
  templateUrl: './side-nav-outer-toolbar.component.html',
  styleUrls: ['./side-nav-outer-toolbar.component.scss'],
  imports: [
    SideNavigationMenuComponent,
    DxDrawerComponent,
    HeaderComponent,
    DxScrollViewComponent,
    DxTemplateDirective
  ],
  standalone: true,
})
export class SideNavOuterToolbarComponent implements OnInit {
  private screen = inject(ScreenService);
  private router = inject(Router);
  private ns = inject(NavigatorService);
  private storageService = inject(StorageService);

  @ViewChild(DxScrollViewComponent, { static: true })
    scrollView: DxScrollViewComponent;
  selectedRoute = '';

  menuOpened: boolean;
  temporaryMenuOpened = false;

  @Input()
    title: string;

  menuMode = 'shrink';
  menuRevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;

  isBase: boolean = true;

  ngOnInit() {
    this.isBase = this.storageService.utenteCorrente.ruoloString == RUOLO_OPERATORE_BASE;
    this.menuOpened = this.screen.sizes['screen-large'];

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split('?')[0];
      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];

    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = isXSmall ? 0 : 60;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }
  

  navigationChanged(event) {
    const path = event.itemData.path;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      if (event.node.selected) {
        pointerEvent.preventDefault();
        this.ns.doubleClickMenu(path);
        // window.location.reload();
      } else {
        this.router.navigate([path]);
        this.scrollView.instance.scrollTo(0);
      }

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent.stopPropagation();
      }
    } else {
      pointerEvent.preventDefault();
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}
